// extracted by mini-css-extract-plugin
export default {"link":"Navlink_link__54+5L","active":"Navlink_active__WAKps"};